module.exports = __webpack_public_path__ + "static/media/diametro.e0e7a60e.png";